"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("@airasia/phoenix-components/components/Theme/constant");
var _constants = require("./constants");
var _default = {
  PropTypes: {
    data: _propTypes.default.shape({
      productTile: _propTypes.default.string,
      iconUrl: _propTypes.default.string,
      attractText: _propTypes.default.string,
      showSearchWidget: _propTypes.default.string,
      redirectionUrl: _propTypes.default.string,
      newTab: _propTypes.default.string,
      productID: _propTypes.default.string,
      cnDisclaimerLine1: _propTypes.default.string,
      showSearchWidgetMobile: _propTypes.default.string,
      onClick: _propTypes.default.func,
      productTitle: _propTypes.default.string
    }).isRequired,
    theme: _propTypes.default.string,
    index: _propTypes.default.number,
    gtmParameters: _propTypes.default.string,
    handleGtm: _propTypes.default.func,
    widgetFunction: _propTypes.default.func,
    isMobile: _propTypes.default.bool.isRequired,
    background: _propTypes.default.oneOf(_constant.ARR_BACKGROUND_COLORS),
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    isFirst: _propTypes.default.bool,
    isLast: _propTypes.default.bool,
    maxWidthDesktop: _propTypes.default.string,
    maxWidthMobile: _propTypes.default.string,
    showArrow: _propTypes.default.bool,
    textColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    animationType: _propTypes.default.oneOf(Object.values(_constants.ANIMATION_TYPE)),
    deviceType: _propTypes.default.string,
    tileType: _propTypes.default.oneOf(Object.keys(_constants.TILE_TYPES)),
    highlightTileByDeFaultId: _propTypes.default.string,
    queryParamsPresent: _propTypes.default.bool,
    version: _propTypes.default.string,
    getProductData: _propTypes.default.func,
    shouldFireGTM: _propTypes.default.bool,
    idConfig: _propTypes.default.exact({
      parentName: _propTypes.default.string,
      widgetName: _propTypes.default.string,
      index: _propTypes.default.string
    }),
    itemFlexDirection: _propTypes.default.string,
    tileImageDesktopWidth: _propTypes.default.string,
    tileImageDesktopHeight: _propTypes.default.string,
    tileImageMobileWidth: _propTypes.default.string,
    tileImageMobileHeight: _propTypes.default.string
  },
  defaultProps: {
    theme: _constant.DEFAULT_THEME,
    isMobile: false,
    accessible: true,
    isFirst: false,
    isLast: false,
    showArrow: false,
    highlightTileByDeFaultId: null,
    queryParamsPresent: false,
    gtmParameters: null,
    index: null,
    handleGtm: function handleGtm() {},
    maxWidthDesktop: _constants.MAX_WIDTH_DESKTOP,
    maxWidthMobile: _constants.MAX_WIDTH_MOBILE,
    animationType: _constants.ANIMATION_TYPE.noAnimation,
    tileType: _constants.TILE_TYPES.PRODUCT_TILE,
    version: 'v1',
    getProductData: function getProductData() {}
  }
};
exports.default = _default;